<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener("variant:change", function(event) {
  const variant = event.detail.variant;

  if (!variant || !variant.compare_at_price) return;

  let discount = variant.compare_at_price - variant.price;
  let percent = Math.round((discount * 100) / variant.compare_at_price);

  let badge = document.querySelector(".product-label--sale");

  if (badge && percent > 0) {
    badge.innerHTML = percent + "% OFF";
  }
});